/**
 * Returns the caller name from a softphone remote identity of the form
 * `<caller name> (<caller number or user id>)`, e.g.
 * `Jenny Abovsky (+13232044277)` → `Jenny Abovsky`.
 *
 * Returns `undefined` when the value is not a string, when there is no name
 * part, or when the name part is just the number again
 * (`13232044277 (+13232044277)`), so callers can keep showing the number.
 * @param remoteIdentity - The softphone remote identity
 */
const getRemoteIdentityName = (
  remoteIdentity?: unknown,
): string | undefined => {
  if (typeof remoteIdentity !== 'string') {
    return undefined;
  }

  // String parsing instead of a regex, so a long value cannot cause backtracking
  const identity = remoteIdentity.trim();
  const open = identity.lastIndexOf('(');

  if (open < 0 || !identity.endsWith(')') || identity.indexOf(')') < open) {
    return undefined;
  }

  const name = identity.slice(0, open).trim();

  if (!name || /^\+?\d+$/.test(name)) {
    return undefined;
  }

  return name;
};

export default getRemoteIdentityName;
